// Textos y reglas de claridad (separados de los componentes para que el «fast refresh» siga funcionando).
import type { Columna, CriterioVacante, EstadoCriterio, Veredicto } from "@/reclutamiento/tipos";
import { guardarPref, leerPref } from "./util";

/** Lo que significa la marca grande de cada candidato, dicho en corto. */
export const TITULO_VEREDICTO: Record<Veredicto, string> = {
  cumple: "Cumple todo",
  revisar: "Revisar: le falta algo",
  descartado: "No pasó el filtro",
};

/** Una línea debajo de cada etapa que dice qué hacer con esa gente. */
export const SUBTITULO_COLUMNA: Record<Columna, string> = {
  cumple: "Pasaron el filtro: contáctalos",
  revisar: "Les falta algo: revisa su CV",
  contactado: "Ya les escribiste",
  entrevistado: "Ya los entrevistaste",
  contratado: "Ya los contrataste",
  algun_dia: "Guardados para después",
  descartado: "Ya no siguen en el proceso",
};

/** Textos de los requisitos de cada vacante: vacante → clave → criterio. */
export type TextosRequisitos = Map<string, Map<string, CriterioVacante>>;
export function textosDeVacantes(vs: { id: string; criterios: CriterioVacante[] }[] | null | undefined): TextosRequisitos {
  const m: TextosRequisitos = new Map();
  (vs ?? []).forEach((v) => m.set(v.id, new Map(v.criterios.map((c) => [c.clave, c]))));
  return m;
}

export type Req = { clave: string; estado: EstadoCriterio; dato: string | null };
/** «experiencia_tecnico» → «Experiencia tecnico» (cuando la vacante no trae el texto). */
const humano = (clave: string) => {
  const t = clave.replace(/[_-]+/g, " ").trim();
  return t ? t[0].toUpperCase() + t.slice(1) : "Requisito";
};
const nombreReq = (c: Req, cv?: CriterioVacante) => cv?.texto || humano(c.clave);
/** Cómo se lee un requisito en la lista: lo que cumple, o lo que le falta. */
export const lineaReq = (c: Req, cv?: CriterioVacante) =>
  c.estado === "ok" ? nombreReq(c, cv) : c.estado === "no" ? cv?.texto_no || `No cumple: ${nombreReq(c, cv)}` : `Por confirmar: ${nombreReq(c, cv)}`;

/** «Cumple 3 de 4 requisitos. No cumple: Diagnostica con escáner.» */
export function resumenRequisitos(crit: Req[], textos?: Map<string, CriterioVacante>): string {
  if (!crit.length) return "Sin requisitos cargados";
  const ok = crit.filter((c) => c.estado === "ok").length;
  const no = crit.filter((c) => c.estado === "no").map((c) => nombreReq(c, textos?.get(c.clave)));
  const falta = crit.filter((c) => c.estado === "falta").map((c) => nombreReq(c, textos?.get(c.clave)));
  if (ok === crit.length) return `Cumple los ${crit.length} requisitos`;
  return [
    `Cumple ${ok} de ${crit.length} requisitos.`,
    no.length ? `No cumple: ${no.join(", ")}.` : "",
    falta.length ? `Por confirmar: ${falta.join(", ")}.` : "",
  ]
    .filter(Boolean)
    .join(" ");
}

const CLAVE_GUIA = "guia-claridad-v1";
export const guiaVista = () => leerPref(CLAVE_GUIA) === "vista";
export const marcarGuiaVista = () => guardarPref(CLAVE_GUIA, "vista");
